import React, { FC } from 'react'
import Box from '@mui/material/Box'
import { Gateway, Sensor } from 'src/api'
import { GatewayColumnsDataGrid } from 'src/components/columns/gateway'
import { CommonGatewayList } from '../gateway/gatewayList/commonGatewaysList'

const columns = [
  GatewayColumnsDataGrid.DeviceId,
  GatewayColumnsDataGrid.Contractor,
  GatewayColumnsDataGrid.Project,
  GatewayColumnsDataGrid.LastPingAt,
]

interface SensorGatewaysProps {
  sensor: Sensor
}

export const SensorGateways: FC<SensorGatewaysProps> = ({ sensor }) => {
  const gateways: Gateway[] =
    sensor.gatewaySensors?.map((gs) => gs.gateway).filter((g): g is Gateway => !!g) || []

  return (
    <Box height="400px">
      <CommonGatewayList
        columns={columns}
        count={gateways.length}
        data={gateways}
        isLoading={false}
        autoHeight={false}
      />
    </Box>
  )
}
